import { render, staticRenderFns } from "./customizationFeaturedEntrepreneurshipsSection.vue?vue&type=template&id=fba23278"
import script from "./customizationFeaturedEntrepreneurshipsSection.vue?vue&type=script&lang=js"
export * from "./customizationFeaturedEntrepreneurshipsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports